// import createSagaMiddleware from "redux-saga";
import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./reducers/rootReducer";
// import  rootSaga from './authSaga';
import logger from "redux-logger";

// const sagaMiddleware = createSagaMiddleware();
export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    process.env.REACT_APP_ENV_VAR === "dev"
      ? getDefaultMiddleware().concat(logger)
      : getDefaultMiddleware(),
  // middleware: getDefaultMiddleware().concat([sagaMiddleware, logger]),
});
// sagaMiddleware.run(rootSaga);
export default store;
